import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconFullScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H10V5.5H5.5V10H2.5V4Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.5 4C21.5 3.17157 20.8284 2.5 20 2.5H14V5.5H18.5V10H21.5V4Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.5 20C2.5 20.8284 3.17157 21.5 4 21.5H10V18.5H5.5V14H2.5V20Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.5 20C21.5 20.8284 20.8284 21.5 20 21.5H14V18.5H18.5V14H21.5V20Z",
			fill: "black"
		})
	]
});
export default SvgIconFullScreen;
